if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

const elementsOnPage = (query, timeout, multiple=false) => {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();
    const tryQuery = () => {
      const elem = multiple
        ? [].slice.call(document.querySelectorAll(query))
        : document.querySelector(query);
      if (multiple ? elem.length : elem) {
        resolve(elem);
      } else if (Date.now() - startTime > timeout) {
        resolve(null);
      } else {
        setTimeout(tryQuery, 10);
      }
    }
    tryQuery(); // Initial check
  });
};

Promise.all([
  elementsOnPage('.product__title', 2000),
  elementsOnPage('#bcontact-custom_1648126830003', 2000),
]).then(([title, select]) => {
  const productName = title.innerText.toLowerCase();
  const selectedOption = [].slice.call(select.options).filter(o =>
    o.value.toLowerCase() == productName)[0];
  if(selectedOption) {
    select.value = selectedOption.value;
  }
});

Promise.all([
  elementsOnPage('[name="quantity"]', 1500),
  elementsOnPage('[id*="price-template"]', 1500),
  elementsOnPage('.price-preview', 1500),
  elementsOnPage('.price-preview-container', 1500),
  elementsOnPage('.department-select input', 1500, true),
  elementsOnPage('.product-form__buttons', 1500),
  elementsOnPage('.bcontact-182069, .bcontact-183405', 2000),
]).then(([
  quantitySelect,
  priceItem,
  pricePreview,
  pricePreviewContainer,
  departmentRadios,
  submitContainer,
  quoteForm,
]) => {
  if(pricePreviewContainer) {
    observePrice(priceItem);

    quantitySelect.addEventListener('change', updatePrice);
    departmentRadios && departmentRadios.forEach(r => r.addEventListener('change', updatePrice));

    updatePrice();

    const quoteSelect = quoteForm.querySelector('select');
    quoteSelect.value = document.querySelector('.product__title').textContent.replace(/^\s+|\s+$/gm, '');
  } else {
    quoteForm.classList.toggle('visible', true);
  }

  function updatePrice(e) {
    const basePrice = parseFloat(priceItem.querySelector('.price-item').textContent.replace(',', '.').replace(/[^\d.]/g, ''));
    const quantity = parseInt(quantitySelect.value, 10);
    const selectedRadio = departmentRadios && departmentRadios.filter(r => r.checked)[0];
    const isValidShipping = selectedRadio ? selectedRadio.value == 'yes' : false;

    const departmentWasSelected = selectedRadio != null;

    submitContainer.classList.toggle('no-add', departmentRadios && !isValidShipping);
    pricePreviewContainer.classList.toggle('hidden', departmentRadios && !isValidShipping);
    quoteForm.classList.toggle('visible', departmentWasSelected && !isValidShipping);

    if (!departmentRadios || isValidShipping) {
      const price = basePrice * quantity;
      pricePreview.innerText = toCurrency(price);
    }
  }

  function parseDepartment(label) {
    return parseInt(label, 10);
  }

  function parseShippingCost(label) {
    return parseFloat(label.replace(/.*\(([^\)]+)\).*/, '$1'));
  }

  function numberToCurrency(p) {
    return
  }

  function observePrice(target) {
    const config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = function(mutationsList, observer) {
      // Use traditional 'for loops' for IE 11
      for(const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          updatePrice();
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(target, config);

  }
});

function toCurrency(price, options={}) {
  price = Math.ceil(price * 100) / 100;
  const currency = options.currency || '€';
  const missing = options.missing || '';
  price = localizedNumber(price);

  return price ? `${price} ${currency}` : missing;
}

function localizedNumber(n) {
  if(n != undefined) {
    let [integer, decimal] = String(n).split('.');
    integer = groupBy(integer.split(''), 3).join(' ');
    decimal = fillRight(decimal || '', 2);

    return `${integer},${decimal}`
  } else {
    return '';
  }
}

const groupBy = (a,g) => {
  const res = [];

  while(a.length > g) {
    res.unshift(a.splice(-g, g).join(''));
  }
  res.unshift(a.join(''));

  return res;
}

const fillRight = (s, l, r='0') => {
  while(s.length < l) {
    s = `${s}${r}`;
  }
  return s;
}
